import React from 'react';

const Settings = () => {
    return (
        <div className="max-w-3xl mx-auto">
            <h1 className="text-2xl font-bold text-slate-900 mb-8">Account Settings</h1>

            <div className="bg-white border border-slate-200 rounded-xl shadow-sm divide-y divide-slate-100">

                {/* Profile Section */}
                <div className="p-6">
                    <h2 className="text-lg font-bold text-slate-900 mb-4">Profile Information</h2>
                    <div className="grid md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-1">Full Name</label>
                            <input type="text" className="input" defaultValue="Alex Founder" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-1">Email Address</label>
                            <input type="email" className="input" defaultValue="alex@autoinventor.com" />
                        </div>
                    </div>
                </div>

                {/* Password Section */}
                <div className="p-6">
                    <h2 className="text-lg font-bold text-slate-900 mb-4">Security</h2>
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-1">Current Password</label>
                            <input type="password" className="input" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-1">New Password</label>
                            <input type="password" className="input" />
                        </div>
                        <button className="btn btn-secondary">Update Password</button>
                    </div>
                </div>

                {/* Danger Zone */}
                <div className="p-6 bg-red-50/50">
                    <h2 className="text-lg font-bold text-red-600 mb-2">Danger Zone</h2>
                    <p className="text-sm text-slate-500 mb-4">Once you delete your account, there is no going back. Please be certain.</p>
                    <button className="btn bg-white border border-red-200 text-red-600 hover:bg-red-50">Delete Account</button>
                </div>
            </div>
        </div>
    );
};

export default Settings;
